import Axios from "axios";
import {
    SET_ASSET_COMPONENTS_LIST,
    UNSET_ASSET_COMPONENTS_LIST,
} from "@/store/mutation-types";

import { saveUpdateAssetComponent, getAssetComponentsList, getAssetComponentById } from "@/store/api";

const state = {
    getAssetComponentsList: [],
    getEditingAssetComponent: null,
};

const getters = {
    getAssetComponentsList(state) {
        return state.getAssetComponentsList;
    },
};

const mutations = {
    [SET_ASSET_COMPONENTS_LIST](state, data) {
        state.getAssetComponentsList = data;
    },
    [UNSET_ASSET_COMPONENTS_LIST](state) {
        state.getAssetComponentsList = [];
    },
};

const actions = {
    saveUpdateAssetComponent({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetComponent, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetComponentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetComponentsList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_COMPONENTS_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_COMPONENTS_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetComponentById({ commit }, data) {
        const getAssetComponentsById = `${getAssetComponentById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetComponentsById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
